import Card from 'react-bootstrap/Card';
import Table from 'react-bootstrap/Table';
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';

import styles from '../../App.module.css';
import useHttp from '../../hooks/use-http';
import { getApplications } from '../../lib/api';
import LoginDb from '../Login/LoginDb';

// TODO: Make the thing select only assigned applications, and check for completion by reviewer
const Rnd1ReviewHome = () => {

  const isAuth = useSelector( state => state.user.isReviewer);

  // const [isAuth, setIsAuth] = useState( false );
  const [gotResponse, setGotResponse] = useState( false );
  const { sendRequest, status, data: queryRes } = useHttp( getApplications );
  // const { sendGradesRequest, gradesStatus, data: gradesQueryRes } = useHttp( getCompletedRevs );


  useEffect( () => {
    sendRequest({year: true});
  }, [sendRequest] );

  useEffect( () => {
    if ( status === 'completed' ) {
      setGotResponse( true );
    }
  }, [status] );

  // useEffect( () => {
  //   setIsAuth(authState); 
  // }, [authState])

  return (
    <div>
    { isAuth ?  ( 
    <Card body className={styles['Card']}>
      <Card.Title className={styles['page-header']}>Review homepage</Card.Title>
      <Card body className={[styles['CardLvl2']]}>
        <Table striped hover>
          <thead>
            <tr>
              <th>ID (click to view)</th>
              <th>Author</th>
              <th>Link to review</th>
            </tr>
          </thead>
          <tbody>
            {gotResponse && queryRes && queryRes.map( ( app, idx ) => (
              <tr key={idx}>
                <td><Link to={`../rnd1view/${app.id}`} target={'_blank'}>{app.id}</Link></td>
                <td>{app.fname ? ( `${app.fname} ${app.lname}` ) : 'N/A'}</td>
                <td><Link to={`${app.id}`}>Review</Link></td>
              </tr>
            ) )}
          </tbody>
        </Table>
      </Card>
    </Card>
    ) :
    (<LoginDb />)}
  </div>
  );
};

export default Rnd1ReviewHome;